import React from 'react'
import { Container } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import PartnerData from '../partner_data';
import { Link } from 'react-router-dom';
import ProductDescription from './../components/Product_description'

const Product_lists = () => {
    const params = useParams();
    const brand = PartnerData.find(brand => brand.url === params.id);

    return (
        <div>
            <Container>
                <div className="min-h-full items-center text-center sm:px-6 lg:px-8 w-full">
                    <ProductDescription partner_url={brand.partner_url} image={brand.image} image_width={brand.image_width} image_height={brand.image_height} className={brand.className} description={brand.description}/>
                    <div className="py-5 pb-4" id="product_list">
                        {brand.products.map((product) => (
                            <Link to={`/products/${product.url}/${product.type_url}`} className="text-center px-2 pb-2">
                                <div className="flex items-center justify-center w-full h-full">
                                    <img src={`/images/product_images/${brand.image_upper_path}/${brand.image_cover_path}/${product.type_image}.jpg`} alt={`cover_logo`} style={{}} className="inline-block"/>
                                </div>
                                    <h2 className="anton pb-3 text-lg font-bold">{product.type}</h2>
                            </Link>
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Product_lists
